export default __webpack_public_path__ + "884d9db2c64881ea02db1ad73a75c384.css";